/** The one access policy for `/ngos`, applied by its layout guard before any `ngo.*` query mounts. */
import { ngoLoginRedirectPath, type NgoReturnLocation } from './ngo-session';

/** Also rendered without sidebar chrome. Route ids, because the browser URL omits the internal `/ngos` prefix. */
export const PUBLIC_NGO_ROUTE_PREFIXES = ['/ngos/login', '/ngos/select-ngo', '/ngos/onboarding', '/ngos/auth/callback'];

/** Signed in, but on a page of their own with no sidebar: the act of signing a contract (TEC-3932). */
export const FOCUSED_NGO_ROUTE_PREFIXES = ['/ngos/contracts/'];

export function isFocusedNgoRoute(routeId: string): boolean {
	return FOCUSED_NGO_ROUTE_PREFIXES.some((prefix) => routeId.startsWith(prefix));
}

export type NgoRedirect = { to: '/ngos/login'; search: { redirect: string | undefined } };

export function isPublicNgoRoute(routeId: string): boolean {
	return PUBLIC_NGO_ROUTE_PREFIXES.some((prefix) => routeId.startsWith(prefix));
}

/** Pass the location from the guard's first render; it only builds the post-login target. */
export function resolveNgoRouteAccess(input: {
	routeId: string;
	signedIn: boolean;
	location: NgoReturnLocation;
}): NgoRedirect | null {
	const { routeId, signedIn, location } = input;
	if (isPublicNgoRoute(routeId)) return null;
	if (signedIn) return null;
	return { to: '/ngos/login', search: { redirect: ngoLoginRedirectPath(location) } };
}
